import { Box } from 'braid-design-system';

import { Insights } from 'src/app/v1/views/components/Insights';

import * as styles from './index.css';

export interface InsightsSectionProps {
  renderGenerateAdSection?: boolean;
}

export const InsightsSection = ({
  renderGenerateAdSection = false,
}: InsightsSectionProps) => (
  <Box className={styles.container}>
    <Insights renderGenerateAdSection={renderGenerateAdSection} />
  </Box>
);
